<script>
  import { onMount } from 'svelte';
  import { api } from '@util/Fetch';
  const chevron_right = "/assets_default/icons/chevron_right.svg"

  const { limit = 10, enableShowMore = true } = $props();

  let voiceCase = $state([]);
  let loading = $state(true);
  let error = $state(null);
  let displayCount = $state(limit);

  async function fetchVoiceCases() {
    loading = true;
    error = null;
    try {
      const data = await api.get(`/assets_default/data/voiceCase.json`);
      // データを 'date' の値で最新順（降順）に並べ替える
      voiceCase = data.item.sort((a, b) => new Date(b.date) - new Date(a.date));
    } catch (e) {
      error = e.message;
    } finally {
      loading = false;
    }
  }

  onMount(() => {
    fetchVoiceCases();
  });

  function showAllItems() {
    displayCount = voiceCase.length;
  }
  let itemsToShow = $derived(voiceCase.slice(0, displayCount));
  let showMoreButton = $derived(enableShowMore && voiceCase.length > displayCount);
</script>

{#if loading}
  <p>読み込み中...</p>
{:else if error}
  <p class="error">エラーが発生しました: {error}</p>
{:else}
  <ul class="owd-card-wrap:vertical">
    {#each itemsToShow as item}
    <li class="owd-card owd-card:link bg-colors:primary-wh">
      <a href="{item.link}">
        <img src="{item.keyvisual}" width="120" height="120" alt="ダミー">
          <div class="owd-card:link-textarea">
            {#if item.status === true}
            <div class="owd-servicesticker owd-servicesticker:yellow spacing:bottom:8">
              <p class="owd-label owd-servicesticker-label">NEW</p>
            </div>
            {/if}
            {#if item.subtitle}
              <div class="owd-sub owd-sub:small spacing:bottom:12">
                <span class="owd-sub-marker"></span>
                <p class="owd-information">{item.subtitle.replace(/[\[\]]/g, '')}</p>
              </div>
            {/if}
            <p class="owd-caption spacing:bottom:12"><strong>{@html item.title}</strong></p>
            <p class="owd-information">{item.days}</p>
          </div>
          <img class="owd-card-icon" src="{chevron_right}" alt="右矢印アイコン">
      </a>
    </li>
    {/each}
  </ul>

  {#if showMoreButton}
  <div class="spacing:bottom:16 block:center">
    <button class="owd-text:02" on:click={showAllItems}>
      <strong><span class="owd-textlink">もっと見る</span></strong>
    </button>
  </div>
  {/if}
{/if}


<style lang="scss">
button{
  background: none;
  border: none;
  margin-top: 40px;
}
.error {
  color: red;
}

</style>
